import * as B from '@blueprintjs/core';
import React from 'react';

/**
 * B.Icon combining the polygon-filter icon with a plus centered inside the
 * polygon's hollow interior, following the Blueprint evenodd pattern.
 *
 * All three subpaths share the same 320x320 glyph coordinate space and
 * transform. The evenodd rule fills the plus through the existing hole.
 *
 * Subpaths:
 *   1. Polygon-filter outer shape (node circles + connecting outline)
 *   2. Polygon-filter inner hole
 *   3. Plus centered at glyph (140,140) = SVG (-1,1), shifted slightly left and
 *      down from the geometric centroid to correct for the polygon's visual
 *      asymmetry. Derived from the Blueprint add-location plus shifted by
 *      (-120,-120) from its original center at (260,260).
 */
const PolygonPlusIcon: React.FunctionComponent<React.PropsWithChildren<{size?: number}>> = ({
  size = 16,
}) => (
  <B.Icon
    icon={
      <span className="bp5-icon">
        <svg width={size} height={size} viewBox="-8 -8 16 16" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M280 220C275.2 220 270.6 219 266.4 217.4L199.4 273.2C199.6 275.4 200 277.6 200 280C200 302 182 320 160 320S120 302 120 280C120 279.2 120.2 278.4 120.2 277.6L57.6 235.8C52.2 238.4 46.4 240 40 240C18 240 0 222 0 200C0 185.2 8 172.4 20 165.6V74.6C8 67.6 0 54.8 0 40C0 18 18 0 40 0C54.8 0 67.6 8 74.4 20H165.4C172.4 8 185 0 199.8 0C221.8 0 239.8 18 239.8 40C239.8 47.4 237.6 54 234.2 60L280 140C302.2 140.2 320 158 320 180C320 202 302 220 280 220zM199.8 80C185.2 80 172.4 71.8 165.6 60H74.6C71 66 66 71 60 74.4V165.6C72 172.4 80 185.2 80 200C80 200.8 79.8 201.6 79.8 202.4L142.4 244.2C147.8 241.6 153.6 240 160 240C164.8 240 169.4 241 173.6 242.6L240.6 186.8C240.4 184.6 240 182.4 240 180C240 172.6 242.2 166 245.6 160L199.8 80zM140 200C151.045694 200 154 191.045695 154 186L154 154.02L186 154C191.045694 154 200 151.045695 200 140C200 128.954305 191.045694 126 186 126L154 126L154 100C154 88.954305 151.045694 80 140 80C128.954306 80 126 88.954305 126 94L126 126L94 126C88.954306 126 80 128.954305 80 140C80 151.045695 88.954306 154 94 154L126 154L126 186C126 191.045695 128.954306 200 140 200z"
            fillRule="evenodd"
            transform="scale(0.05, -0.05) translate(-160, -160)"
          />
        </svg>
      </span>
    }
  />
);

export default PolygonPlusIcon;
